export enum SectionType {
  Weight = 'weight',
  Medical = 'medical',
  Summary = 'summary',
}
